import { ReactNode } from "react";
import { Flex } from "@chakra-ui/react";
import { FragmentType, getFragmentData, gql } from "__generated__/gql";
import { SKU_COMPONENT_TYPE_LABELS_SHORT } from "components/Products/SkuPanel/SkuComponents/utils";
import { sortSkuComponents } from "components/Products/utils";
import LabeledValueBadge from "components/Shared/LabeledValueBadge";
import { formatUpc } from "components/Shared/Forms/UpcInput";

const fragment = gql(/* GraphQL */ `
  fragment LabeledSkuComponentUpc on SkuComponent {
    id
    skuComponentType
    upc
  }
`);

type Props = {
  fallback?: ReactNode;
  skuComponents: FragmentType<typeof fragment>[];
};

export default function LabeledSkuComponentUpcs({
  fallback = null,
  skuComponents: skuComponentFragments,
}: Props) {
  const skuComponents = getFragmentData(fragment, skuComponentFragments);

  const displayed = sortSkuComponents(skuComponents).filter(
    (skuComponent): skuComponent is typeof skuComponent & { upc: string } =>
      !!skuComponent.upc,
  );

  if (!displayed.length) return fallback;

  return (
    <Flex gap={1} flexDirection="column" alignItems="flex-start">
      {displayed.map((skuComponent) => (
        <LabeledValueBadge
          key={skuComponent.id}
          label={SKU_COMPONENT_TYPE_LABELS_SHORT[skuComponent.skuComponentType]}
          value={formatUpc(skuComponent.upc)}
          labelProps={{ minW: "4.1em", textAlign: "center" }}
          valueProps={{
            fontFamily: "mono",
            fontWeight: "normal",
            fontSize: "xs",
          }}
        />
      ))}
    </Flex>
  );
}
